<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Wifi" class="d-icon d-icon--wifi" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M6 3a7 7 0 0 0-4.667 1.783.5.5 0 0 1-.666-.746 8 8 0 0 1 10.666 0 .5.5 0 1 1-.666.746A7 7 0 0 0 6 3Zm0 2.57a4.5 4.5 0 0 0-3.15 1.287.5.5 0 1 1-.7-.714 5.5 5.5 0 0 1 7.7 0 .5.5 0 1 1-.7.714A4.5 4.5 0 0 0 6 5.571Zm0 2.465a2 2 0 0 0-1.4.572.5.5 0 1 1-.7-.714 3 3 0 0 1 4.2 0 .5.5 0 0 1-.7.714A2 2 0 0 0 6 8.035ZM5.5 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconWifi',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
